import { useIdleTimer } from 'react-idle-timer';

import { useAppSelector } from '@store';

import { handleUnCommittedData } from '@service/eventService';

import { useLogout } from './useLogout';

export const useAutoLogout = (
  CT_URL_LINK: string,
  isElectron: boolean,
  isFromCtSimulator: boolean,
) => {
  const { branchTypeConfig } = useAppSelector((state) => state.branchInfo);
  const { autoLogoutTime } = branchTypeConfig;
  const { logoutForgerock } = useLogout();

  const handleIdleTimeout = () => {
    if (isElectron) {
      // when in electron, send the user back to counter terminal
      window.location.href = CT_URL_LINK;
      return;
    }

    if (isFromCtSimulator) {
      // when in CT simulator, close the Back Office window
      window.close();
      return;
    }

    handleUnCommittedData(); //To store uncommited data before logout
    // on BYOD, log the user out
    logoutForgerock();
  };

  useIdleTimer({
    timeout: autoLogoutTime,
    onIdle: handleIdleTimeout,
    disabled: process.env.NEXT_PUBLIC_DISABLE_AUTO_LOGOUT === 'true',
  });
};
